module.exports = __webpack_public_path__ + "img/9788972975571.0676d266.jpg";